import React from "react";
import { FileViewerContainer } from "components/common";
import { ImageMeta } from "models/propTypes/fileViewerPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { useCashReconciliationService } from "serviceHooks";

function useCashReconciliationFileViewer(
  key: number,
  cashReconciliationId?: number,
  cashReconciliationAttachments?: WintSuperkollAPIModel.CashReconciliationAttachment[]
) {
  const cashReconciliationService = useCashReconciliationService();

  const getAttachments = () =>
    cashReconciliationId
      ? cashReconciliationAttachments !== undefined && cashReconciliationAttachments.length > 0
        ? cashReconciliationAttachments.map((meta) => {
            const imageMeta: ImageMeta = {
              id: meta.attachmentId as string,
              fileName: meta.fileName,
              contentType: meta.contentType,
              numberOfPages: 1,
              data: meta.data,
              loading: (meta as ImageMeta).loading,
            };
            return imageMeta;
          })
        : undefined
      : undefined;

  const getAttachment = async (fileId: string | number, index: number) => {
    if (cashReconciliationId !== undefined) {
      const attachment = await cashReconciliationService.getAttachment(cashReconciliationId, fileId as string);
      return attachment.data ?? "";
    }
    return "";
  };

  const fileViewerComponent = React.useMemo(() => {
    return (
      <FileViewerContainer
        key={key}
        meta={getAttachments()}
        parentId={cashReconciliationId ?? 0}
        loading={cashReconciliationId === undefined}
        getFile={getAttachment}
      />
    );
  }, [key, cashReconciliationAttachments, cashReconciliationId]);

  return fileViewerComponent;
}

export default useCashReconciliationFileViewer;
